var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RoyStar"},[_c('StyledStar',_vm._b({},'StyledStar',_vm.style,false),[_c('span',{staticClass:"iconfont roy-star-icon",class:_vm.style.icon})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }